import _ from 'lodash';

export const getInsuredAccessLabels = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.insuredAccessLabels`,
    {},
  );
};

export const getInsuredPolicyListApiUrl = (state: {}): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.insuredPolicyListApiUrl`,
    '',
  );
};

export const getInsuredPolicyDetailApiUrl = (state: {}): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.insuredPolicyDetailApiUrl`,
    '',
  );
};

export const getInsuredAccessApiUrl = (state: {}): string => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.customerProfileApi.insuredAccessApiUrl`,
    '',
  );
};

export const getInsuredPolicyList = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.policyList`,
    [],
  );
};

export const getIsLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.isLoading`,
    false,
  );
};

export const getAccessIsLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.accessIsLoading`,
    false,
  );
};

export const getError = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.error`,
    false,
  );
};

export const getAccessCustState = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.accessCustState`,
    {},
  );
};

export const getDeactivationCustState = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.insuredAccess.deactivationCustState`,
    {},
  );
};
